import {
  CarrierSpendOverTimeRequestSchema,
  CarrierSpendOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getCarrierSpendOverTime = {
  name: "getCarrierSpendOverTime" as const,
  input: CarrierSpendOverTimeRequestSchema,
  output: CarrierSpendOverTimeResponseSchema,
};
